<fgb-navigation-indicator></fgb-navigation-indicator>

<fgb-nav-bar *ifScreenSize="screenType.Desktop"></fgb-nav-bar>

<ng-container *ifScreenSize="screenType.Desktop">
  <fgbcl-notification-toast></fgbcl-notification-toast>
</ng-container>

<div id="main" role="main">
  <router-outlet></router-outlet>
</div>

<fgb-footer></fgb-footer>
